import React from "react"
import Logo from "../components/logo"
import {Container,Row,Col,Button} from "react-bootstrap"

const Header = () => (
  <header>
      <a href="#main" id='skipnav' tabIndex='-1'>Skip to main content</a>
      <Container>
        <Row >
          <Col className='leftSide'>
            <Logo></Logo>
            <div className='text'>
              <div className='topText'>Benjamin Oxenford</div>
              <div className='bottomText'>Congius LLC</div>
            </div>
          </Col>
          <Col className='rightSide'>
            <Button className="cg-dark" href="#contactForm">Contact</Button>
          </Col>
        </Row>
      </Container>
  </header>
)

export default Header
